<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Login Page</title>
    <link rel="stylesheet" href="login.component.scss" />
  </head>
  <body>
    <div class="container">
      <!-- Environment info as non-form content -->
      <div *ngIf="applyBlueBg" style="background-color: lightblue; width:500px;">
        <strong style="margin-left: 180px; margin-top: 20px; margin-bottom: 20px; color: black;">
          Dev Environment
        </strong>
      </div>
      <div *ngIf="applyRedBg" style="background-color: red;width:500px;">
        <strong style="margin-left: 180px; margin-top: 20px; margin-bottom: 20px; color: white;">
          QA Environment
        </strong>
      </div>

      <main>
        <!-- Off-screen heading for accessibility -->
        <h1 class="sr-only">Login Page</h1>

        <div class="login-box">
          <div class="logo-container">
            <img
              src="assets/images/e-logo.png"
              alt="eligibility logo"
              style="max-height: 100%; max-width: 150px;"
            />
          </div>
          <div class="login-instructions">
            <h2>Welcome!</h2>
            <p class="instruction">
              Log in to check your eligibility and continue your application.
            </p>
          </div>
          <p class="login-method">Sign in with your work or school account
          </p>
          <button (click)="signInWithAzureAD()" class="signin-button button-default custom-btn-primary">
            Sign in
          </button>
        </div>
      </main>
    </div>
  </body>
</html>
